/**
 * Dashboard > Dashboard - 일별 선택된 Area 이상 검출 건수 조회 component
 */
import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'DailyFaultStatsOfArea',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    parentInfo (value) {
      var nMonth = value.date
      var area = value.area
      if (nMonth && area) {
        this.search(this.parentInfo)
      }
    }
  },
  methods: {
    /**
     * Chart Data 조회 (일별 선택된 Area 이상 검출 건수)
     */
    async search (condition) {
      const payload = {
        // fab: 'BRIQUE',
        area: condition.area,
        nMonth: condition.date
      }
      this.areaTitle = condition.area
      this.monthTitle = condition.date

      await API.Monitor.getDailyFaultStatsOfArea(payload, this.callbackDailyFaultStatsOfArea, [this.$refs.dailyFaultStatsOfAreaChart])
    },
    /**
     * Chart Data 조회 callback
     * @param {*} response Chart Data 조회 결과
     */
    callbackDailyFaultStatsOfArea (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)
      }
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      traces.forEach(trace => {
        if (trace.name === 'All') {
          trace.type = 'line'
        } else {
          trace.type = 'bar'
        }
        trace.hovertemplate = '%{y:,}'
      })
      const layout = {
        xaxis: {
          type: 'category',
          tickangle: 'auto'
        },
        hovermode: 'x unified'
      }
      const config = {
        responsive: true,
        displayModeBar: false
      }
      BriqueChart.newPlot('dailyFaultStatsOfAreaChart', traces, layout, config)
    }
  },
  data () {
    return {
      rowData: [], // chart data
      areaTitle: null, // 상위 component 에서 선택된 Area 정보
      monthTitle: null // 상위 component에서 선택된 월 정보
    }
  }
}
